<template>
    <div class="allresource-view" ref="resourceListWrapper">
        <div>
            <div class="allresource-view-body">
                <div class="cates-mask">
                    <h5>
                        {{ langTransfer('全部分类') }}
                        <template v-if="isShowResouceCount">
                         ({{resourceCatesTotal}})
                        </template>
                    </h5>
                    <div class="cates-list-wrapper">
                        <div class="cates-list">
                            <div v-for="(item,index) in cates"
                                 :key="index"
                                 class="cate-item"
                                 @click="changeType(item)" title="拖动列表或滑动鼠标滚轮可以显示更多分类">
                                <p :style="{color: index === checkedTypeIndex ? themeColor : ''}">
                                    {{ item.CategoryName }}
                                </p>
                                <span v-if="isShowResouceCount">{{ item.ResourceTotal }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="resource-list-mask">
                    <div class="resource-list-header">
                        <h5><i :style="{background: themeColor}"
                               class="warning-icon"/>{{ cates.length > 0 ? cates[checkedTypeIndex].CategoryName : '' }}</h5>
                    </div>
                    <div  class="resource-list-wrapper">
                        <div :class="resourceListClassName" class="resource-list-body">
                            <div class="list-body-mask">
                                <template v-if="resourceType === 'audio' || resourceType === 'video'">
                                    <div v-for="(item,index) in resourceListData.Data"
                                         :key="index"
                                         class="resource-item"
                                         @click="goDetail(item)">
                                        <img :src="item.__cover">
                                        <h5>{{ item.Name }}</h5>
                                        <p :title="item.__bottomInfo">{{ item.__bottomInfo }}</p>
                                    </div>
                                    <div class="resource-item" style="height: 0;"/>
                                    <div class="resource-item" style="height: 0;"/>
                                    <div class="resource-item" style="height: 0;"/>
                                </template>
                                <template v-else>
                                    <div v-for="(item,index) in resourceListData.Data"
                                         :key="index"
                                         class="resource-item"
                                         @click="goDetail(item)">
                                        <img :src="item.CoverImages[3]"  v-if="resourceType === 'magazine' && item.CoverImages" :src2="item.CoverImages[2]" @error="$tools.nocover">
                                        <img :src="item.__cover" v-else>
                                        <h5>{{ item.Name }}</h5>
                                        <span>{{ item.__midInfo }}</span>
                                    </div>
                                    <div class="resource-item" style="height: 0;"/>
                                    <div class="resource-item" style="height: 0;"/>
                                    <div class="resource-item" style="height: 0;"/>
                                </template>
                            </div>
                            <!-- <div class="site-footer">
                                <Footer/>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="site-footer">
                 <Footer/>
            </div>
        </div>
        
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        data () {
            return {
                catesListBScroll: null,
                allCatesBScroll: null,
                // checkedTypeIndex: 0,
                resourceType: '',
                cates: [],
                resourceListData: {},
                lastParams: {}
            }
        },
        computed: {
            isShowResouceCount()
            {
                return this.$store.state.isShowResouceCount
            },
            resourceCatesTotal () {
                let counts=0;
                const { cates, resourceType } = this
                if (resourceType === 'audio' || resourceType === 'video') {
                    cates.forEach((item)=>{
                        counts+=item.ResourceTotal;
                    });
                    return counts+'集';
                }
                cates.forEach((item)=>{
                        counts+=item.ResourceTotal;
                });
                if (resourceType === 'book'){
                    return counts+'本';
                }
                if (resourceType === 'magazine' || resourceType==='newspaper'){
                    return counts+'种';
                }
                
            },
            resourceListClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine',
                    'newspaper-likely': resourceType === 'newspaper',
                    'video-likely': resourceType === 'video'
                }
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            checkedTypeIndex () {
                const { cates, $route } = this
                const { cateCode } = $route.params
                if (!cates || cates.length <= 0) {
                    return 0
                }
                const index = cates.findIndex((e) => {
                    return e.CategoryCode === cateCode
                })
                return index === -1 ? 0 : index
            }
        },
        mounted () {
            this.initBScroll()
        },
        activated () {
        },
        methods: {
            initBScroll () {
                if (this.allCatesBScroll) {
                    this.allCatesBScroll.refresh()
                    this.allCatesBScroll.finishPullUp()
                    return
                }

                this.allCatesBScroll = new BScroll(this.$refs.resourceListWrapper, {
                    bounce: false,
                    click: true,
                    pullUpLoad: {
                        threshold: 150
                    },
                    mouseWheel: {
                        speed: 20,
                        invert: false,
                        easeTime: 300
                    }
                })
                this.allCatesBScroll.on('pullingUp', () => {
                    try {
                        this.pullUpLoadHandler()
                    } catch (error) {
                        console.log(error)
                    }
                })
                // this.catesListBScroll = new BScroll(this.$refs.catesListWrapper, {
                //     bounce: false,
                //     click: true,
                //     mouseWheel: {
                //         speed: 20,
                //         invert: false,
                //         easeTime: 300
                //     }
                // })
            },
            changeType (item) {
                const { name, params } = this.$route
                params.cateCode = item.CategoryCode
                this.$router.replace({
                    name,
                    params
                })
            },
            goDetail (item) {
                const { resourceType, cates, checkedTypeIndex } = this
                const cate = cates[checkedTypeIndex]
                this.$tools.goDetailRoute.call(this, resourceType, item, cate)
            },
            async getCatesList () {
                try {
                    const { resourceType, $route } = this
                    const { Data } = await this.$apis(resourceType).getCatesList()
                    this.cates = Data
                    if (Data.length > 0) {
                        const { cateCode } = $route.params
                        const categoryCode = cateCode === 'all' ? Data[0].CategoryCode : cateCode
                        this.getListByCate(categoryCode)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getListByCate (cateCode, pageindex = 1, pagesize = 15) {
                try {
                    const { resourceType, resourceListData } = this
                    const data = await this.$apis(resourceType)
                        .getListByCate(cateCode, pageindex, pagesize);
                    const toolFnName = `format${ this.$tools.forMatFirstWord(resourceType) }Data`
                    data.Data = this.$tools[toolFnName](data.Data)
                    this.allCatesBScroll.refresh()
                    if (resourceListData.Data && resourceListData.Data.length > 0) {
                        data.Data = resourceListData.Data.concat(data.Data);

                        //this.allCatesBScroll.finishPullUp()
                    }
                    this.resourceListData = data
                    this.$nextTick(()=>{
                       this.initBScroll()
                    })  
                } catch (error) {
                    console.log(error)
                }
            },
            pullUpLoadHandler () {
                const {
                    cates, checkedTypeIndex, resourceListData, allCatesBScroll
                } = this
                const { CategoryCode, ResourceTotal } = cates[checkedTypeIndex]
                const { Data, PageIndex } = resourceListData
                if (Data && Data.length < ResourceTotal) {
                    this.getListByCate(CategoryCode, PageIndex + 1)
                    return
                }

                //allCatesBScroll.finishPullUp()
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { cateCode } = to.params
            this.lastParams = to.params
            this.resourceListData = {}
            this.getListByCate(cateCode)
            next()
        },
        beforeRouteEnter (to, from, next) {
                            
            next((vm) => {
                const { params } = vm.$route
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const { resourceType } = params
                vm.resourceType = resourceType
                vm.cates = []
                vm.resourceListData = {}
                vm.getCatesList()
            })
        }

    }
</script>

<style lang="scss" scoped>
    .allresource-view {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .allresource-view-body {
        width: 1140px;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        padding-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
    }

    .cates-mask {
        width: 270px;
        margin-right: 20px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;

        h5 {
            width: 100%;
            height: 50px;
            padding: 0 16px;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            border-bottom: 1px solid #F0F2F7;
        }

        .cates-list-wrapper {
            width: 100%;
            max-height: 416px;
            // overflow: hidden;
        }

        .cates-list {
            padding: 8px 0;
            height: 400px;
            overflow-y: auto;
            overflow-x: hidden;
        }

        .cate-item {
            width: 100%;
            box-sizing: border-box;
            padding: 0 16px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;

            p {
                
                font-size: 14px;
                color: #1A1A1A;
                line-height: 40px;
            }

            span {
                
                font-size: 14px;
                color: #8590A6;
                text-align: right;
                line-height: 40px;
            }
        }

        .cate-item:hover {
            background: #F6F6F6;
        }
    }

    .resource-list-mask {
        // position: absolute;
        top: 20px;
        bottom: 20px;
        left: 290px;
        right: 0;
        background: #fff;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .resource-list-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding: 0 34px 0 16px;
        background: #fff;
        border-bottom: 1px solid #F0F2F7;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        h5 {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            position: relative;
            padding-left: 12px;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            background: #0084FF;
            border-radius: 2px;
            position: absolute;
            left: 0;
            top: 17px;
        }
    }

    .site-footer {
        // position: absolute;
        bottom: 0;
        left: 0;
    }

    .resource-list-wrapper {
        // overflow: hidden;
        //position: absolute;
        top: 50px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 850px;
    }

    .magazine-likely.resource-list-body, .book-likely.resource-list-body,.newspaper-likely.resource-list-body {
        min-height: 100%;
        box-sizing: border-box;
        padding: 16px 16px 16px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .resource-item {
            width: 150px;
            height: 248px;
            margin-bottom: 16px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            img {
                display: block;
                width: 150px;
                height: 190px;
                border-radius: 4px;
                cursor: pointer;
                box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                margin: 14px 0 8px;
                cursor: pointer;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                cursor: pointer;
                max-width: 150px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    .audio-likely.resource-list-body, .video-likely.resource-list-body{
        min-height: 100%;
        box-sizing: border-box;
        padding: 20px 16px 16px;

        .list-body-mask {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
        }

        .resource-item {
            width: 150px;
            height: 208px;
            margin-bottom: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            img {
                display: block;
                width: 150px;
                height: 150px;
                border-radius: 4px;
                cursor: pointer;
                box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
            }

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 22px;
                margin-top: 4px;
                margin: 14px 0 8px;
                cursor: pointer;
            }

            p {
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                height: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                max-width: 150px;
            }
        }
    }
</style>
